import React from 'react';

import { connect } from 'react-redux';
import { hideSponsoredWarning } from 'services/actions/productsActions';
import { requestRemoveFromCart } from 'services/actions/cartActions';

import BaseModal from '../../../shared-components/BaseModal/Modal';
import GwpPopupsContentWrapper from './GwpPopupsContentWrapper';
import { gwpModalDefaultContentStyles } from './GwpModalDefaultContentStyles';

const RemoveGWPWarningPopup = (props) => {
  const {
    shouldDisplayRemoveGWPWarningPopup,
    hideSponsoredWarning,
    requestRemoveFromCart,
  } = props;

  return (
    <BaseModal
      showCloseIcon={false}
      isOpen={shouldDisplayRemoveGWPWarningPopup}
      onRequestClose={hideSponsoredWarning}
      shouldCloseOnOverlayClick
      styles={gwpModalDefaultContentStyles}
    >
      <GwpPopupsContentWrapper
        title="Are You Sure You Want to Remove This Free Gift?"
        description="Quantities are limited and you might not have an opportunity to add this again!"
        requestRemoveFromCart={requestRemoveFromCart}
        hideSponsoredWarning={hideSponsoredWarning}
      />
    </BaseModal>
  );
};

const mapStateToProps = (state) => {
  return {
    shouldDisplayRemoveGWPWarningPopup:
      state.productsState.shouldDisplayRemoveGWPWarningPopup,
  };
};

export default connect(mapStateToProps, {
  hideSponsoredWarning,
  requestRemoveFromCart,
})(RemoveGWPWarningPopup);
